
export class WCCCustomEvents {

    constructor ( event, params ) {

        if (typeof CustomEvent === 'function') {
            return new CustomEvent(event, params);
        }

        params = params || { bubbles: false, cancelable: false, detail: undefined };
        const evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/wcc-custom-event.ts